/**
 * API kullanıcı nesnelerinde silinmiş kullanıcı gösterimi (isDeleted) için ortak metin ve kontroller.
 */

export type UserPresenceFields = {
  isDeleted?: boolean;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  role?: string | null;
  thumbnailUrl?: string | null;
};

export function isUserDeleted(user: UserPresenceFields | null | undefined): boolean {
  return user?.isDeleted === true;
}

export function getUserBaseDisplayName(
  user: UserPresenceFields | null | undefined,
  userIdFallback?: number | null
): string {
  if (!user) {
    return userIdFallback != null ? `User ${userIdFallback}` : "Unknown user";
  }
  const parts = [user.firstName, user.lastName].filter((p) => p && String(p).trim());
  if (parts.length) return parts.join(" ");
  if (user.email) return user.email;
  return userIdFallback != null ? `User ${userIdFallback}` : "Unknown user";
}

export const DELETED_USER_LABEL = "(deleted user)";

/** İsim + gerekiyorsa " (deleted user)" */
export function getUserDisplayNameWithDeleted(
  user: UserPresenceFields | null | undefined,
  userIdFallback?: number | null
): string {
  const base = getUserBaseDisplayName(user, userIdFallback);
  if (isUserDeleted(user)) {
    return `${base} ${DELETED_USER_LABEL}`;
  }
  return base;
}

/** Mention seçiminde inputa yazılacak tam metin (mapping anahtarı ile aynı olmalı) */
export function getMentionTokenForInput(user: UserPresenceFields & { firstName?: string | null }): string {
  const base = user.firstName?.trim() || user.email?.split("@")[0] || "user";
  const at = `@${base}`;
  if (isUserDeleted(user)) {
    return `${at} ${DELETED_USER_LABEL}`;
  }
  return at;
}

export function findShareMemberByEmail(
  email: string,
  ...pools: (readonly unknown[] | null | undefined)[]
): UserPresenceFields | undefined {
  const target = String(email || "").trim().toLowerCase();
  if (!target) return undefined;
  for (const pool of pools) {
    if (!pool?.length) continue;
    for (const raw of pool) {
      const u = raw as { email?: string | null };
      if (u?.email && String(u.email).trim().toLowerCase() === target) {
        return raw as UserPresenceFields;
      }
    }
  }
  return undefined;
}
